/**
 * Generates a unique entry ID for funnel data tracking
 * Format: timestamp + random string
 * Example: 1701234567890_a1b2c3d4
 * 
 * @returns {string} Unique entry ID
 */
export const generateEntryId = () => {
  const timestamp = Date.now()
  const randomStr = Math.random().toString(36).substring(2, 10)
  return `${timestamp}_${randomStr}`
}

/**
 * Validates if an entry ID is in the correct format
 * @param {string} entryId - The entry ID to validate
 * @returns {boolean} True if valid
 */
export const isValidEntryId = (entryId) => {
  if (!entryId || typeof entryId !== 'string') return false
  const pattern = /^\d+_[a-z0-9]+$/
  return pattern.test(entryId)
}


